import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-287a3b4e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex gap-2" };
import { onBeforeMount, ref, watch } from "vue";
import OneDeskTable from "@/components/organisms/OneDeskTable.vue";
import { userColumns } from "@/shared/utils/columns-definition/user";
import { FilterMatchMode } from "primevue/api";
import { getAllUsersPaginated } from "@/repositories/users.repository";
import Button from "primevue/button";
import Tag from "primevue/tag";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdminUserTable',
    props: /*#__PURE__*/ _mergeModels({
        reloadContent: { type: Boolean, default: false }
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*#__PURE__*/ _mergeModels(["content-reloaded"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const model = _useModel(__props, "modelValue");
        const props = __props;
        const loading = ref(false);
        const usersList = ref([]);
        const pageNumber = ref(1);
        const pageSize = ref(10);
        const totalCount = ref(0);
        const totalPages = ref(0);
        const search = ref("");
        const loadUsersList = async () => {
            loading.value = true;
            const paginatedUsersList = await getAllUsersPaginated(pageNumber.value, pageSize.value, search.value);
            usersList.value = paginatedUsersList.items;
            totalCount.value = paginatedUsersList.totalCount;
            totalPages.value = paginatedUsersList.totalPages;
            loading.value = false;
        };
        onBeforeMount(async () => {
            await loadUsersList();
        });
        const onSearchChange = (searchText) => {
            pageNumber.value = 1;
            search.value = searchText;
        };
        watch([pageNumber, pageSize, search], async () => {
            await loadUsersList();
        });
        watch(() => props.reloadContent, async () => {
            if (props.reloadContent)
                await loadUsersList();
            emit("content-reloaded");
        });
        const emit = __emit;
        const userColumnsDefinition = ref(userColumns);
        const globalFilterFields = ref(["displayName", "account", "id"]);
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        const onEditClick = (data) => {
            model.value = data;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(OneDeskTable, {
                title: "Accounts",
                loading: loading.value,
                "columns-definition": userColumnsDefinition.value,
                "table-data": usersList.value,
                class: _normalizeClass('user_table'),
                filters: filters.value,
                "global-filter-fields": globalFilterFields.value,
                "has-pagination": true,
                "page-index": pageNumber.value,
                "page-size": pageSize.value,
                "total-records": totalCount.value,
                onPageChange: _cache[0] || (_cache[0] = ($event) => pageNumber.value = $event + 1),
                "row-click": onEditClick,
                onSearchChange: _cache[1] || (_cache[1] = ($event) => (onSearchChange($event))),
                "on-row-click": ($event) => onEditClick($event)
            }, {
                isAdmin: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.item.adminRoles, (role) => {
                            return (_openBlock(), _createBlock(_unref(Tag), {
                                key: role,
                                icon: "pi pi-check-circle",
                                severity: "success",
                                value: role.replace('Admin', '')
                            }, null, 8, ["value"]));
                        }), 128))
                    ])
                ]),
                actions: _withCtx((slotProps) => [
                    _createVNode(_unref(Button), {
                        size: "small",
                        severity: "primary",
                        icon: "pi pi-user-edit",
                        label: "Edit",
                        onClick: ($event) => (onEditClick(slotProps.item))
                    }, null, 8, ["onClick"])
                ]),
                account: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.item.account), 1)
                ]),
                _: 1
            }, 8, ["loading", "columns-definition", "table-data", "filters", "global-filter-fields", "page-index", "page-size", "total-records", "on-row-click"]));
        };
    }
});
